import { gql, TypedDocumentNode } from '@common/hooks';
import {
  WorkforceGroupByIdQueryCgResponse,
  WorkforceGroupByIdQueryVariables,
  WorkforceGroupQueryCgResponse,
  WorkforceGroupQueryVariables,
  WorkforceGroupsQueryQueryCgResponse,
  WorkforceGroupsQueryQueryVariables,
} from '@common/graphql/schema';

export type WorkforceGroupFlatType =
  WorkforceGroupQueryCgResponse['workforceGroups'][number];

export const WORKFORCE_GROUP_FLAT_QUERY: TypedDocumentNode<
  WorkforceGroupQueryCgResponse,
  WorkforceGroupQueryVariables
> = gql`
  query WorkforceGroup {
    workforceGroups {
      id
      name
    }
  }
`;

export const WorkforceGroupById: TypedDocumentNode<
  WorkforceGroupByIdQueryCgResponse,
  WorkforceGroupByIdQueryVariables
> = gql`
  query WorkforceGroupById($workforceGroupId: ID!) {
    workforceGroup(workforceGroupId: $workforceGroupId) {
      id
      name
      active
      activeWorkersCount
      description
      consecutiveHoursLimit
      consecutiveHoursBridgeTolerance
      consecutiveHoursResetPeriod
      weeklyMaximumHours
      weeklyMinimumHours
      hideHomeUnitName
      hideFloatUnitName
      updatedAt
      utilizationRule
      defaultConfig {
        id
        gateOpenShiftsVisibility
        gateEarliestAdvanceTime
        earliestAdvanceTime
        earliestAdvanceTimeFormat
        openShiftsVisibilityDelayHours
        openShiftsVisibilityDelayHoursFormat
        updatedAt
      }
    }
  }
`;

export const WORKFORCE_GROUPS_QUERY: TypedDocumentNode<
  WorkforceGroupsQueryQueryCgResponse,
  WorkforceGroupsQueryQueryVariables
> = gql`
  query WorkforceGroupsQuery($workforceGroupInput: WorkforceGroupInput) {
    workforceGroups(input: $workforceGroupInput) {
      id
      name
      activeWorkersCount
      updatedAt
      active
      defaultConfig {
        id
        gateOpenShiftsVisibility
        gateEarliestAdvanceTime
        earliestAdvanceTime
        earliestAdvanceTimeFormat
        openShiftsVisibilityDelayHours
        openShiftsVisibilityDelayHoursFormat
        updatedAt
      }
    }
  }
`;

export type WorkforceGroupType =
  WorkforceGroupByIdQueryCgResponse['workforceGroup'];

export type WorkforceGroupResponse = {
  workforceGroups: WorkforceGroupType[];
};
